import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid my-3"
}
const _hoisted_2 = { class: "d-flex mb-4" }
const _hoisted_3 = { class: "avatar-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "text-body-secondary"
}
const _hoisted_6 = {
  key: 2,
  class: "player-btns mt-3"
}
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6 col-xl-5" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = {
  key: 0,
  class: "table table-bordered ratings-table"
}
const _hoisted_12 = { class: "text-nowrap" }
const _hoisted_13 = {
  rowspan: "2",
  colspan: "2",
  class: "text-center mb-0"
}
const _hoisted_14 = { class: "col-lg-6 col-xl-7" }
const _hoisted_15 = { class: "mt-4" }
const _hoisted_16 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_17 = { class: "table" }
const _hoisted_18 = { scope: "col" }
const _hoisted_19 = { scope: "col" }
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = { scope: "col" }
const _hoisted_22 = { scope: "col" }
const _hoisted_23 = { class: "ps-0" }
const _hoisted_24 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_25 = { class: "d-none d-md-inline" }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "mt-3" }
const _hoisted_29 = { class: "mx-3" }
const _hoisted_30 = {
  key: 4,
  class: "table-responsive"
}
const _hoisted_31 = { class: "table mb-0" }
const _hoisted_32 = { scope: "col" }
const _hoisted_33 = { scope: "col" }
const _hoisted_34 = { scope: "col" }
const _hoisted_35 = { scope: "col" }
const _hoisted_36 = { scope: "col" }
const _hoisted_37 = { scope: "col" }
const _hoisted_38 = { class: "ps-0" }
const _hoisted_39 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_40 = { class: "d-none d-md-inline" }
const _hoisted_41 = {
  key: 0,
  style: {"width":"7em"}
}
const _hoisted_42 = {
  key: 1,
  style: {"width":"7em"},
  class: "text-success"
}
const _hoisted_43 = {
  key: 2,
  style: {"width":"7em"},
  class: "text-danger"
}
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = {
  key: 5,
  class: "mt-3"
}
const _hoisted_47 = { class: "mx-3" }
const _hoisted_48 = {
  key: 1,
  class: "container"
}
const _hoisted_49 = { class: "text-center lead mt-2" }

import { storeToRefs } from 'pinia';
import useAuthStore from '../../../stores/authStore.js';
import { BIconPerson, BIconPersonUp, BIconBoxArrowRight, BIconGear, BIconTrophyFill } from 'bootstrap-icons-vue';
import { HostedGame, Player, PlayerStats, Rating } from '../../../../shared/app/models/index.js';
import { getPlayerBySlug, ApiClientError, apiGetPlayerStats, apiGetPlayerCurrentRatings, getGames } from '../../../apiClient.js';
import { Ref, ref, watch } from 'vue';
import { format } from 'date-fns';
import useLobbyStore from '../../../stores/lobbyStore.js';
import AppPseudo from '../../components/AppPseudo.vue';
import AppOnlineStatus from '../../components/AppOnlineStatus.vue';
import AppTimeControlLabelVue from '../../components/AppTimeControlLabel.vue';
import AppGameRulesSummary from '../../components/AppGameRulesSummary.vue';
import AppPlayerStats from '../../components/AppPlayerStats.vue';
import AppPlayerRatingChart from '../../components/AppPlayerRatingChart.vue';
import AppTablePlayerRating from '../../components/AppTablePlayerRating.vue';
import AppSearchGamesParameters from '../../components/AppSearchGamesParameters.vue';
import { useRoute, useRouter } from 'vue-router';
import { injectHead, useSeoMeta } from '@unhead/vue';
import { definePerson, useSchemaOrg } from '@unhead/schema-org';
import { pseudoString } from '../../../../shared/app/pseudoUtils.js';
import { formatDistanceToNowStrict } from 'date-fns';
import { timeControlToCadencyName } from '../../../../shared/app/timeControlUtils.js';
import useServerDateStore from '../../../stores/serverDateStore.js';
import { watchEffect } from 'vue';
import { RatingCategory } from '../../../../shared/app/ratingUtils.js';
import { Directive } from 'vue';
import SearchGamesParameters from '../../../../shared/app/SearchGamesParameters.js';
import { getOtherPlayer, hasPlayer } from '../../../../shared/app/hostedGameUtils.js';
import { useSearchGamesPagination } from '../../composables/searchGamesPagination.js';

const DEFAULT_PAGE_SIZE = 15;


export default /*@__PURE__*/_defineComponent({
  __name: 'PagePlayer',
  setup(__props) {

/* eslint-env browser */
const { slug } = useRoute().params;

if (Array.isArray(slug)) {
    throw new Error('Unexpected array in "slug" param');
}

const head = injectHead();

/*
 * Player meta tags
 */
const updateMeta = (player: Player): void => {
    useSeoMeta({
        title: pseudoString(player, 'pseudo'),

        // index only bots (Mohex) profile page.
        // Guest should never be indexed,
        // players only if they explicitely agree (settings)
        robots: player.isBot ? 'index' : 'noindex',

        ogTitle: `${pseudoString(player, 'pseudo')}`,
        ogType: 'profile',
        ogUrl: window.location.href,
        twitterCard: 'summary',
    }, { head });

    useSchemaOrg(head, [
        definePerson({
            name: pseudoString(player, 'pseudo'),
            url: window.location.href,
        }),
    ]);
};

/*
 * Player data
 */
const { loggedInPlayer } = storeToRefs(useAuthStore());
const isMe = (): boolean => null !== loggedInPlayer.value && loggedInPlayer.value.slug === slug;

const player: Ref<null | Player> = isMe()
    ? loggedInPlayer
    : ref(null)
;

const playerNotFound = ref(false);

(async () => {
    try {
        if (null === player.value) {
            player.value = await getPlayerBySlug(slug);
        }

        updateMeta(player.value);
    } catch (e) {
        if (!(e instanceof ApiClientError)) {
            throw e;
        }

        playerNotFound.value = true;
    }
})();

/*
 * Current games
 */
const { hostedGames } = storeToRefs(useLobbyStore());

const currentGameComparator = (a: HostedGame, b: HostedGame): number => {
    // Correspondence games go after real-time games, then sorted by "started at"
    const timeA = timeControlToCadencyName(a.gameOptions);
    const timeB = timeControlToCadencyName(b.gameOptions);

    if (timeA !== 'correspondence' && timeB === 'correspondence')
        return -1;

    if (timeA === 'correspondence' && timeB !== 'correspondence')
        return 1;

    const startedAtA = a.gameData?.startedAt;
    const startedAtB = b.gameData?.startedAt;

    if (startedAtA != null && startedAtB != null)
        return startedAtB.getTime() - startedAtA.getTime();

    return 0;
};

const getCurrentGames = (): HostedGame[] => {
    if (null === player.value) {
        return [];
    }

    const currentGames: HostedGame[] = [];

    for (const hostedGame of Object.values(hostedGames.value)) {
        if ('playing' !== hostedGame.state || !hasPlayer(hostedGame, player.value)) {
            continue;
        }

        currentGames.push(hostedGame);
    }

    return currentGames.sort(currentGameComparator);
};

/*
 * Games history
 */
const gamesHistory = ref<null | HostedGame[]>(null);
const totalResults = ref<null | number>(null);
const searchGamesParameters = ref<SearchGamesParameters>({
    players: null === player.value
        ? undefined
        : [{ publicId: player.value.publicId }]
    ,
    opponentType: 'player',
    states: ['ended'],
    endedAtSort: 'desc',
    paginationPageSize: DEFAULT_PAGE_SIZE,
});

const { totalPages, goPagePrevious, goPageNext } = useSearchGamesPagination(
    searchGamesParameters,
    totalResults,
    DEFAULT_PAGE_SIZE,
);

// Set filter to current player, but keep same filter if already set on this player
watch(player, newPlayer => {
    if (null === newPlayer) {
        return;
    }

    if (undefined === searchGamesParameters.value.players
        || searchGamesParameters.value.players.every(p => p.publicId !== newPlayer.publicId)
    ) {
        searchGamesParameters.value.players = [
            { publicId: newPlayer.publicId },
        ];
    }
});

// Update games list when filters change
watchEffect(async () => {
    // Do not search yet to prevent having games without current player,
    // which is impossible to display in this page table because we need to display the opponent to currentPlayer
    if (undefined === searchGamesParameters.value.players || 0 === searchGamesParameters.value.players.length) {
        return;
    }

    const { results, count } = await getGames(searchGamesParameters.value);

    gamesHistory.value = results;
    totalResults.value = count;
});

const hasWon = (game: HostedGame): boolean => {
    if (null === player.value) {
        throw new Error('player must be set');
    }

    if (null === game.gameData) {
        throw new Error('no gameData');
    }

    if (null === game.gameData.winner) {
        return false;
    }

    const winner = game.hostedGameToPlayers[game.gameData.winner].player;

    return winner.publicId === player.value?.publicId;
};

const getOpponent = (game: HostedGame): Player => {
    if (null === player.value) {
        throw new Error('player must be set');
    }

    let me: null | Player = null;
    let opponent: null | Player = null;

    for (const p of game.hostedGameToPlayers) {
        if (p.player.publicId === player.value.publicId) {
            me = p.player;
        } else {
            opponent = p.player;
        }
    }

    if (null === me || null === opponent) {
        throw new Error('Player not in the game, or no opponent');
    }

    return opponent;
};

const router = useRouter();

const clickLogout = async () => {
    gamesHistory.value = [];
    const newPlayer = await useAuthStore().logout();

    router.push({
        name: 'player',
        params: {
            slug: newPlayer.slug,
        },
    });
};

/**
 * ping and date shift
 */
const { pingTime, medianShift } = storeToRefs(useServerDateStore());

/*
 * Player stats
 */
const playerStats = ref<null | PlayerStats>(null);

watchEffect(async () => {
    if (null === player.value) {
        playerStats.value = null;
        return;
    }

    playerStats.value = await apiGetPlayerStats(player.value.publicId);
});

const playerCurrentRatings = ref<null | Partial<Record<RatingCategory, Rating>>>(null);

watchEffect(async () => {
    if (null === player.value) {
        playerStats.value = null;
        return;
    }

    playerCurrentRatings.value = null;
    const ratings = await apiGetPlayerCurrentRatings(player.value.publicId);

    if (null === ratings) {
        return;
    }

    playerCurrentRatings.value = {};

    for (const rating of ratings) {
        playerCurrentRatings.value[rating.category] = rating;
    }
});

const ratingChart = ref<typeof AppPlayerRatingChart>();

const showRatingCategory = (category: RatingCategory): void => {
    if (!ratingChart.value) {
        return;
    }

    ratingChart.value.showRatingCategory(category);
};

const vRating: Directive<HTMLElement, RatingCategory> = {
    mounted: (el, binding) => {
        el.classList.add('clickable-rating');
        el.addEventListener('click', () => {
            showRatingCategory(binding.value);
        });
    },
};

const timeRangeUpdated = (from: null | Date, to: null | Date) => {
    let isZoomed = from || to;

    if (from) {
        searchGamesParameters.value.fromEndedAt = from;
    }

    if (to) {
        searchGamesParameters.value.toEndedAt = to;
    }

    if (isZoomed) {
        searchGamesParameters.value.ranked = true;
        searchGamesParameters.value.opponentType = undefined;
        searchGamesParameters.value.endedAtSort = 'asc';
        searchGamesParameters.value.states = ['ended'];
    } else {
        searchGamesParameters.value.fromEndedAt = undefined;
        searchGamesParameters.value.toEndedAt = undefined;
        searchGamesParameters.value.endedAtSort = 'desc';
    }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!playerNotFound.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(BIconPerson), { class: "icon img-thumbnail" }),
            (_unref(player))
              ? (_openBlock(), _createBlock(AppOnlineStatus, {
                  key: 0,
                  player: _unref(player),
                  class: "player-status"
                }, null, 8, ["player"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, [
              (_unref(player))
                ? (_openBlock(), _createBlock(AppPseudo, {
                    key: 0,
                    player: _unref(player)
                  }, null, 8, ["player"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("…")
                  ], 64))
            ]),
            (_unref(player) && !_unref(player).isGuest)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('account_created_on', { date: _unref(player)?.createdAt
                    ? _unref(format)(_unref(player)?.createdAt, 'd MMMM y')
                    : '…' })), 1))
              : _createCommentVNode("", true),
            (isMe())
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createElementVNode("small", null, _toDisplayString(_ctx.$t('ping.ping_ms', { ms: _unref(pingTime) })) + " – " + _toDisplayString(_ctx.$t('ping.date_shift_ms', { ms: _unref(medianShift) })), 1)
                ]))
              : _createCommentVNode("", true),
            (isMe() && null !== _unref(player))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_unref(player).isGuest)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_router_link, {
                          to: { name: 'signup' },
                          class: "btn btn-success"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(BIconPersonUp)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('create_account')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: { name: 'login' },
                          class: "btn btn-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('log_in')), 1)
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-sm btn-outline-warning",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (clickLogout()))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('log_out')) + " ", 1),
                        _createVNode(_unref(BIconBoxArrowRight))
                      ])),
                  _createVNode(_component_router_link, {
                    to: { name: 'settings' },
                    class: "btn btn-sm btn-outline-primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BIconGear)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('player_settings.title')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (playerStats.value)
          ? (_openBlock(), _createBlock(AppPlayerStats, {
              key: 0,
              playerStats: playerStats.value
            }, null, 8, ["playerStats"]))
          : _createCommentVNode("", true),
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('rating')), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (playerCurrentRatings.value)
                ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
                    _createElementVNode("tbody", _hoisted_12, [
                      _createElementVNode("tr", null, [
                        _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_13, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('overall')), 1),
                          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value.overall,
                            class: "lead"
                          }, null, 8, ["rating"])
                        ])), [
                          [vRating, 'overall']
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("th", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('time_cadency.blitz')), 1)
                        ])), [
                          [vRating, 'blitz']
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("th", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('time_cadency.normal')), 1)
                        ])), [
                          [vRating, 'normal']
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("th", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('time_cadency.correspondence')), 1)
                        ])), [
                          [vRating, 'correspondence']
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value.blitz
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value.normal
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value.correspondence
                          }, null, 8, ["rating"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _withDirectives((_openBlock(), _createElementBlock("th", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('boardsize.small')), 1)
                        ])), [
                          [vRating, 'small']
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value.small
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['small.blitz']
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['small.normal']
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['small.correspondence']
                          }, null, 8, ["rating"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _withDirectives((_openBlock(), _createElementBlock("th", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('boardsize.medium')), 1)
                        ])), [
                          [vRating, 'medium']
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value.medium
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['medium.blitz']
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['medium.normal']
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['medium.correspondence']
                          }, null, 8, ["rating"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _withDirectives((_openBlock(), _createElementBlock("th", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('boardsize.large')), 1)
                        ])), [
                          [vRating, 'large']
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value.large
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['large.blitz']
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['large.normal']
                          }, null, 8, ["rating"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(AppTablePlayerRating, {
                            rating: playerCurrentRatings.value['large.correspondence']
                          }, null, 8, ["rating"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_unref(player))
              ? (_openBlock(), _createBlock(AppPlayerRatingChart, {
                  key: 0,
                  ref_key: "ratingChart",
                  ref: ratingChart,
                  player: _unref(player),
                  onTimeRangeUpdated: timeRangeUpdated
                }, null, 8, ["player"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('player_current_games')), 1),
        (_unref(player))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("table", _hoisted_17, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[6] || (_cache[6] = _createElementVNode("th", { scope: "col" }, null, -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("th", { scope: "col" }, null, -1)),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('game.opponent')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('game.size')), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('game.time_control')), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('game.rules')), 1),
                    _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('game.started')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCurrentGames(), (game) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: game.publicId
                    }, [
                      _createElementVNode("td", _hoisted_23, [
                        _createVNode(_component_router_link, {
                          to: { name: 'online-game', params: { gameId: game.publicId } },
                          class: "btn btn-sm btn-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('game.watch')), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (game.gameOptions.ranked)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                              _createVNode(_unref(BIconTrophyFill)),
                              _cache[8] || (_cache[8] = _createTextVNode()),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('ranked')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(AppPseudo, {
                          rating: "",
                          onlineStatus: "",
                          player: _unref(getOtherPlayer)(game, _unref(player))!
                        }, null, 8, ["player"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(game.gameOptions.boardsize), 1),
                      _createElementVNode("td", null, [
                        _createVNode(AppTimeControlLabelVue, {
                          gameOptions: game.gameOptions
                        }, null, 8, ["gameOptions"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(AppGameRulesSummary, {
                          gameOptions: game.gameOptions
                        }, null, 8, ["gameOptions"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_unref(formatDistanceToNowStrict)(game.gameData?.startedAt ?? 0, { addSuffix: true })), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('player_game_history')), 1),
        _createVNode(AppSearchGamesParameters, { searchGamesParameters: searchGamesParameters.value }, null, 8, ["searchGamesParameters"]),
        (null !== totalResults.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t('n_total_games', { count: totalResults.value })), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_27, "…")),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(goPagePrevious) && _unref(goPagePrevious)(...args))),
            class: _normalizeClass(["btn btn-outline-primary", { disabled: (searchGamesParameters.value.paginationPage ?? 0) < 1 }])
          }, _toDisplayString(_ctx.$t('previous')), 3),
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('page_page_of_max', { page: (searchGamesParameters.value.paginationPage ?? 0) + 1, max: _unref(totalPages) })), 1),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(goPageNext) && _unref(goPageNext)(...args))),
            class: _normalizeClass(["btn btn-outline-primary", { disabled: (searchGamesParameters.value.paginationPage ?? 0) + 1 >= _unref(totalPages) }])
          }, _toDisplayString(_ctx.$t('next')), 3)
        ]),
        (gamesHistory.value && gamesHistory.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("table", _hoisted_31, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("th", { scope: "col" }, null, -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("th", { scope: "col" }, null, -1)),
                    _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('game.outcome')), 1),
                    _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('game.opponent')), 1),
                    _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('game.size')), 1),
                    _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('game.time_control')), 1),
                    _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('game.rules')), 1),
                    _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('game.finished')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gamesHistory.value, (game) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: game.publicId
                    }, [
                      _createElementVNode("td", _hoisted_38, [
                        _createVNode(_component_router_link, {
                          to: { name: 'online-game', params: { gameId: game.publicId } },
                          class: "btn btn-sm btn-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('game.review')), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (game.gameOptions.ranked)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                              _createVNode(_unref(BIconTrophyFill)),
                              _cache[11] || (_cache[11] = _createTextVNode()),
                              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('ranked')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      ('canceled' === game.state)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(_ctx.$t('game_state.canceled')), 1))
                        : (hasWon(game))
                          ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(_ctx.$t('outcome.win')), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(_ctx.$t('outcome.' + (game?.gameData?.outcome ?? 'loss'))), 1)),
                      (game.hostedGameToPlayers.length < 2)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_44, "-"))
                        : (_openBlock(), _createElementBlock("td", _hoisted_45, [
                            _createVNode(AppPseudo, {
                              rating: "",
                              onlineStatus: "",
                              player: getOpponent(game)
                            }, null, 8, ["player"])
                          ])),
                      _createElementVNode("td", null, _toDisplayString(game.gameOptions.boardsize), 1),
                      _createElementVNode("td", null, [
                        _createVNode(AppTimeControlLabelVue, {
                          gameOptions: game.gameOptions
                        }, null, 8, ["gameOptions"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(AppGameRulesSummary, {
                          gameOptions: game.gameOptions
                        }, null, 8, ["gameOptions"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(game.gameData?.endedAt ? _unref(format)(game.gameData.endedAt, 'd MMMM yyyy p') : '-'), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (gamesHistory.value && gamesHistory.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(goPagePrevious) && _unref(goPagePrevious)(...args))),
                class: _normalizeClass(["btn btn-outline-primary", { disabled: (searchGamesParameters.value.paginationPage ?? 0) < 1 }])
              }, _toDisplayString(_ctx.$t('previous')), 3),
              _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('page_page_of_max', { page: (searchGamesParameters.value.paginationPage ?? 0) + 1, max: _unref(totalPages) })), 1),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(goPageNext) && _unref(goPageNext)(...args))),
                class: _normalizeClass(["btn btn-outline-primary", { disabled: (searchGamesParameters.value.paginationPage ?? 0) + 1 >= _unref(totalPages) }])
              }, _toDisplayString(_ctx.$t('next')), 3)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_48, [
        _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('no_such_player')), 1)
      ]))
}
}

})